import axios from "axios";
import { getAPIToken } from "./firebaseAuthentication";
import { APPLICATION_NAME } from "../constant/applicationConstant";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
// GETリクエスト
export const getRequest = async (url, isLoading = true) => {
    if (isLoading) {
        startLoadingDisplay();
    }
    try {
        const response = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + (await getAPIToken()),
                "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
            },
        });
        // ステータス200番台のエラーハンドリング
        if (response.data.success !== true) {
            console.log("status 2XX Error");
            console.log(response.data.dataList);
            throw Error;
        }
        return response.data.dataList;
    }
    catch (error) {
        console.log("error", error);
        throw error;
    }
    finally {
        if (isLoading) {
            endLoadingDisplay();
        }
    }
};
// POSTリクエスト
export const postRequest = async (url, params, isAuthUpdate = false, isLoading = true) => {
    if (isLoading) {
        startLoadingDisplay();
    }
    try {
        const response = await axios.post(url, params, {
            headers: {
                Authorization: "Bearer " + (await getAPIToken(isAuthUpdate)),
                "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
            }
        });
        // Todo暫定
        // ステータス200番台のエラーハンドリング
        // if (response.data.success !== true) {
        //   console.log("status 2XX Error");
        //   throw Error;
        // }
        return response;
    }
    catch (error) {
        console.log("error", error);
        throw error;
    }
    finally {
        if (isLoading) {
            endLoadingDisplay();
        }
    }
};
// POSTリクエスト
export const postCommonRequest = async (url, params, isLoading = true, isAuthed = true, isAuthUpdate = false) => {
    if (isLoading) {
        startLoadingDisplay();
    }
    try {
        const response = await axios.post(url, params, {
            headers: isAuthed
                ? {
                    Authorization: "Bearer " + (await getAPIToken(isAuthUpdate)),
                    "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
                }
                : {
                    "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
                },
        });
        return response;
    }
    catch (error) {
        console.log("postCommonRequest error", error);
        throw error;
    }
    finally {
        if (isLoading) {
            endLoadingDisplay();
        }
    }
};
// PATCHリクエスト
export const patchRequest = async (url, params, isLoading = true) => {
    if (isLoading) {
        startLoadingDisplay();
    }
    try {
        const response = await axios.patch(url, params, {
            headers: {
                Authorization: "Bearer " + (await getAPIToken()),
                "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
            },
        });
        // ステータス200番台のエラーハンドリング
        if (response.data.success !== true) {
            console.log("status 2XX Error");
            throw Error;
        }
        return response;
    }
    catch (error) {
        console.log("error", error);
        throw error;
    }
    finally {
        if (isLoading) {
            endLoadingDisplay();
        }
    }
};
// DELETEリクエスト
export const deleteRequest = async (url, params, isLoading = true) => {
    if (isLoading) {
        startLoadingDisplay();
    }
    try {
        const response = await axios.delete(url, {
            data: params,
            headers: {
                Authorization: "Bearer " + (await getAPIToken()),
                "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
            },
        });
        // ステータス200番台のエラーハンドリング
        if (response.data.success !== true) {
            console.log("status 2XX Error");
            throw Error;
        }
        return response;
    }
    catch (error) {
        console.log("error", error);
        throw error;
    }
    finally {
        if (isLoading) {
            endLoadingDisplay();
        }
    }
};
/**
 * GoogleCloudStorageからトークンを用いてファイルダウンロードを行う
 *
 * @param url GoogleCloudStorageのファイル場所URL
 * @param token GoogleCloudStorageのトークン
 */
export const getGcsFile = async (gcsPath, token) => {
    try {
        const response = await axios.get(gcsPath + "?access_token=" + token);
        return response;
    }
    catch (error) {
        console.log("error", error);
        throw error;
    }
};
